import { cn } from '@/utils/ui/styles'

type SettingsCardProps = {
	children: React.ReactNode
	className?: string
}
/**
 * Settings section container: an elevated card surface (bg-card, shadow-md) that
 * stacks its children on mobile and lays them out as a row on sm+.
 */
export const SettingsCard = ({ children, className }: SettingsCardProps) => {
	return (
		<div
			className={cn(
				'bg-card mb-6 flex w-full flex-col items-start justify-start gap-6 rounded-md p-6 shadow-md sm:flex-row',
				className,
			)}
		>
			{children}
		</div>
	)
}

/**
 * Label column for a {@link SettingsCard} row: a muted, fixed-min-width (36)
 * heading that keeps section titles aligned across cards.
 */
export const SettingsCardTitle = ({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) => {
	return (
		<h2
			className={cn(
				'text-muted-foreground min-w-36 rounded-md py-1 text-sm font-semibold',
				className,
			)}
		>
			{children}
		</h2>
	)
}
